import { Injectable } from '@angular/core';
import { ApiService } from "../api/api.service";

const spinnerCss = `@keyframes opacity-100-25-0-12 {
  0% {opacity: 0.250075;}
  0.01% {opacity: 0.25;}
  0.02% {opacity: 1;}
  0.01% {opacity: 0.25;}
  100% {opacity: 0.250075;}
}
@keyframes opacity-100-25-1-12 {
  0% {opacity: 0.312575;}
  8.34333% {opacity: 0.25;}
  8.35333% {opacity: 1;}
  8.34333% {opacity: 0.25;}
  100% {opacity: 0.312575;}
}
@keyframes opacity-100-25-2-12 {
  0% {opacity: 0.375075;}
  16.6767% {opacity: 0.25;}
  16.6867% {opacity: 1;}
  16.6767% {opacity: 0.25;}
  100% {opacity: 0.375075;}
}
@keyframes opacity-100-25-3-12 {
  0% {opacity: 0.437575;}
  25.01% {opacity: 0.25;}
  25.02% {opacity: 1;}
  25.01% {opacity: 0.25;}
  100% {opacity: 0.437575;}
}
@keyframes opacity-100-25-4-12 {
  0% {opacity: 0.500075;}
  33.3433% {opacity: 0.25;}
  33.3533% {opacity: 1;}
  33.3433% {opacity: 0.25;}
  100% {opacity: 0.500075;}
}
@keyframes opacity-100-25-5-12 {
  0% {opacity: 0.562575;}
  41.6767% {opacity: 0.25;}
  41.6867% {opacity: 1;}
  41.6767% {opacity: 0.25;}
  100% {opacity: 0.562575;}
}
@keyframes opacity-100-25-6-12 {
  0% {opacity: 0.625075;}
  50.01% {opacity: 0.25;}
  50.02% {opacity: 1;}
  50.01% {opacity: 0.25;}
  100% {opacity: 0.625075;}
}
@keyframes opacity-100-25-7-12 {
  0% {opacity: 0.687575;}
  58.3433% {opacity: 0.25;}
  58.3533% {opacity: 1;}
  58.3433% {opacity: 0.25;}
  100% {opacity: 0.687575;}
}
@keyframes opacity-100-25-8-12 {
  0% {opacity: 0.750075;}
  66.6767% {opacity: 0.25;}
  66.6867% {opacity: 1;}
  66.6767% {opacity: 0.25;}
  100% {opacity: 0.750075;}
}
@keyframes opacity-100-25-9-12 {
  0% {opacity: 0.812575;}
  75.01% {opacity: 0.25;}
  75.02% {opacity: 1;}
  75.01% {opacity: 0.25;}
  100% {opacity: 0.812575;}
}
@keyframes opacity-100-25-10-12 {
  0% {opacity: 0.875075;}
  83.3433% {opacity: 0.25;}
  83.3533% {opacity: 1;}
  83.3433% {opacity: 0.25;}
  100% {opacity: 0.875075;}
}
@keyframes opacity-100-25-11-12 {
  0% {opacity: 0.937575;}
  91.6767% {opacity: 0.25;}
  91.6867% {opacity: 1;}
  91.6767% {opacity: 0.25;}
  100% {opacity: 0.937575;}
}`;

const spinnerHtml = `<div role="progressbar" style="position: absolute; width: 0px; z-index: 2000000000; left: 50%; top: 50%;">
    <div style="position: absolute; top: -4px; opacity: 0.25; animation: opacity-100-25-0-12 1s linear 0s infinite normal ;">
      <div style="position: absolute; width: 24px; height: 8px; background: #6ecff6; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px; transform-origin: left center; transform: rotate(0deg) translate(30px, 0px); border-radius: 4px;">
      </div>
    </div>
    <div style="position: absolute; top: -4px; opacity: 0.25; animation: opacity-100-25-1-12 1s linear 0s infinite normal  ;">
      <div style="position: absolute; width: 24px; height: 8px; background: #6ecff6; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px; transform-origin: left center; transform: rotate(30deg) translate(30px, 0px); border-radius: 4px;">
      </div>
    </div>
    <div style="position: absolute; top: -4px; opacity: 0.25; animation: opacity-100-25-2-12 1s linear 0s infinite normal  ;">
      <div style="position: absolute; width: 24px; height: 8px; background: #6ecff6; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px; transform-origin: left center; transform: rotate(60deg) translate(30px, 0px); border-radius: 4px;">
      </div>
    </div>
    <div style="position: absolute; top: -4px; opacity: 0.25; animation: opacity-100-25-3-12 1s linear 0s infinite normal  ;">
      <div style="position: absolute; width: 24px; height: 8px; background: #6ecff6; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px; transform-origin: left center; transform: rotate(90deg) translate(30px, 0px); border-radius: 4px;">
      </div>
    </div>
    <div style="position: absolute; top: -4px; opacity: 0.25; animation: opacity-100-25-4-12 1s linear 0s infinite normal  ;">
      <div style="position: absolute; width: 24px; height: 8px; background: #6ecff6; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px; transform-origin: left center; transform: rotate(120deg) translate(30px, 0px); border-radius: 4px;">
      </div>
    </div>
    <div style="position: absolute; top: -4px; opacity: 0.25; animation: opacity-100-25-5-12 1s linear 0s infinite normal  ;">
      <div style="position: absolute; width: 24px; height: 8px; background: #6ecff6; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px; transform-origin: left center; transform: rotate(150deg) translate(30px, 0px); border-radius: 4px;">
      </div>
    </div>
    <div style="position: absolute; top: -4px; opacity: 0.25; animation: opacity-100-25-6-12 1s linear 0s infinite normal  ;">
      <div style="position: absolute; width: 24px; height: 8px; background: #6ecff6; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px; transform-origin: left center; transform: rotate(180deg) translate(30px, 0px); border-radius: 4px;">
      </div>
    </div>
    <div style="position: absolute; top: -4px; opacity: 0.25; animation: opacity-100-25-7-12 1s linear 0s infinite normal;">
      <div style="position: absolute; width: 24px; height: 8px; background: #6ecff6; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px; transform-origin: left center; transform: rotate(210deg) translate(30px, 0px); border-radius: 4px;">
      </div>
    </div>
    <div style="position: absolute; top: -4px; opacity: 0.25; animation: opacity-100-25-8-12 1s linear 0s infinite normal ;">
      <div style="position: absolute; width: 24px; height: 8px; background: #6ecff6; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px; transform-origin: left center; transform: rotate(240deg) translate(30px, 0px); border-radius: 4px;">
      </div>
    </div>
    <div style="position: absolute; top: -4px; opacity: 0.25; animation: opacity-100-25-9-12 1s linear 0s infinite normal ;">
      <div style="position: absolute; width: 24px; height: 8px; background: #6ecff6; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px; transform-origin: left center; transform: rotate(270deg) translate(30px, 0px); border-radius: 4px;">
      </div>
    </div>
    <div style="position: absolute; top: -4px; opacity: 0.25; animation: opacity-100-25-10-12 1s linear 0s infinite normal;">
      <div style="position: absolute; width: 24px; height: 8px; background: #6ecff6; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px; transform-origin: left center; transform: rotate(300deg) translate(30px, 0px); border-radius: 4px;">
      </div>
    </div>
    <div style="position: absolute; top: -4px; opacity: 0.25; animation: opacity-100-25-11-12 1s linear 0s infinite normal;">
      <div style="position: absolute; width: 24px; height: 8px; background: #6ecff6; box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 1px; transform-origin: left center; transform: rotate(330deg) translate(30px, 0px); border-radius: 4px;">
      </div>
    </div>
  </div>`;

@Injectable({
  providedIn: 'root'
})

export class JsReportService {

  constructor(
    private apiService: ApiService
  ) { }

  printAssessmentReport(dataItem: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise(`assessment/report/`, dataItem, 'printAssessmentReport', 'blob');
  }

  showReportSpinnerPage(reportWindow: any) {
    let page = '<html>' +
      '<style> html, body {padding:0;margin:0;} ' + spinnerCss + '</style>' +
      '<head> <title>Loading...</title> <link rel="icon" type="image/x-icon" href="/favicon.ico"></head>' +
      '<body>' + spinnerHtml +
      '</body></html>';
    reportWindow.document.write(page);
    reportWindow.focus();
  }

  generateReport(reportWindow: any, title: string, url: any) {
    reportWindow.document.open(); //open again to clear spinner page
    const reportWindowHtml = '<html>' +
      '<style> html, body {padding:0;margin:0;} iframe {width:100%;height:100%;border:0}</style>' +
      '<head> <title>' + title + '</title> <link rel="icon" type="image/x-icon" href="/favicon.ico"></head>' +
      '<body>' +
      '<iframe type="application/pdf" src="' + url + '"></iframe>' +
      '</body></html>';
    reportWindow.document.write(reportWindowHtml);
    reportWindow.document.close();
    reportWindow.focus(); //should already have focus
  }

  showReportErrorPage(reportWindow: any, name?: string) {
    let item = name ? name : 'Report';
    reportWindow.document.open(); //open again to clear spinner page
    const reportWindowHtml = `<html>
      <style> body {padding: 40px; margin:auto;} </style>
      <head> <title>SheepDNA</title> <link rel="icon" type="image/x-icon" href="/favicon.ico"></head>
      <body>
      <div ><h1>${item} Temporarily Unavailable</h1>
      <p>There was a problem generating the ${item}. Please try again later.</p>
      </div>
      </body></html>`;
    reportWindow.document.write(reportWindowHtml);
    reportWindow.document.close();
  }

}
